import { ArrayUtil } from "@mcleod/core";
import { DialogProps, PanelProps } from "@mcleod/components";
import { AbstractValueDisplayValueEditor } from "./AbstractValueDisplayValueEditor";

export class HelpLinkEditor extends AbstractValueDisplayValueEditor {
    constructor(currentValueJson: string, props?: Partial<PanelProps>) {
        super(currentValueJson, props);
    }

    override get valueCaption(): string {
        return "Text";
    }

    override get valueName(): string {
        return "text";
    }

    override get displayValueCaption(): string {
        return "URL";
    }

    override get displayValueName(): string {
        return "url";
    }

    override get emptyCaption(): string {
        return "Help links can be defined in this table";
    }

    override getResultValue(): any {
        const result: any[] = [];
        for (const row of this.tableRows) {
            result.push({ text: row.data.get("text", null), url: row.data.get("url", null) });
        }
        if (ArrayUtil.isEmptyArray(result) === false)
            return JSON.stringify(result);
        return null;
    }

    override getDialogProps(): Partial<DialogProps> {
        return {
            ...super.getDialogProps(),
            okDefault: false,
            cursor: null
        }
    }

    protected override getTitle(): string {
        return "Help Links Setup";
    }
}
